import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { hasValue } from 'globalutils/fmUtils';
import { schema } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const FleetManagerForm = ({ apiStatus, clearApiStatus, states, addFleetManagerInfo, getFleetManagerInfo, getCompanyInfoApi }) => {
  const hasApiStatus = hasValue(apiStatus.status, 'api', 'addFleetManager');

  return (
    <div>
      <div className="formLogin forgotPassword">
        <Form
          type="server"
          direction="column"
          initialValues={{
            firstName: getFleetManagerInfo?.firstName ? getFleetManagerInfo.firstName : '',
            lastName: getFleetManagerInfo?.lastName ? getFleetManagerInfo.lastName : '',
            email: getFleetManagerInfo?.email ? getFleetManagerInfo?.email : '',
            userPhone: getFleetManagerInfo?.userPhone ? getFleetManagerInfo.userPhone : '',
            password: '',
          }}
          RenderComponent={RenderComponent}
          handleOnSubmit={(fields) => {
            if (getCompanyInfoApi?.companyId) {
              fields.companyId = getCompanyInfoApi?.companyId;
            }

            delete fields['confPassword'];
            addFleetManagerInfo({
              id: 'addFleetManager',
              data: fields,
            });
          }}
          customProps={{
            hasApiStatus,
            clearApiStatus,
            states,
          }}
          validationSchema={schema}
        />
      </div>
    </div>
  );
};

export default FleetManagerForm;

FleetManagerForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  callback: PropTypes.func,
  clearApiStatus: PropTypes.func.isRequired,
};
